const tags = {
	utm_source: 'utm_source',
	utm_medium: 'utm_medium',
	utm_campaign: 'utm_campaign',
	utm_term: 'utm_term',
	utm_content: 'utm_content',
	data1: 'data1',
	data2: 'data2',
	data3: 'data3',
	data4: 'data4',
	data5: 'data5'
};

const locale = {
	ru: tags,
	en: tags,
	uk: tags,
	de: tags,
	vi: tags,
	th: tags
};

module.exports = {
	enum: tags,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/utm-tags.js